<template>
  <div class="page">
    <Header/>
    <div v-show="isDataVisible" class="container dashboard card">
      <div class="card-header">
        {{ title }}
        <span class="other-buttons">
              <button v-if="showCreateButton" @click="newItemForm()" class="btn btn-primary">New</button>
            </span>
        <span class="special-buttons" v-for="(filterField, filterIndex) in buttons" v-bind:key="filterIndex">
              <button @click="button(filterIndex)" class="btn btn-primary run-btn"
                      :class="filterField.class"
                      v-if="filterField.name !== '' || filterField.name !== undefined"
              >
                  {{ filterField.name }}
              </button>
            </span>
      </div>
      <div class="card-body">
        <div class="alert alert-info alert-dismissable" v-show="info != ''">
          <strong>
            <b-icon icon="info-circle-fill"></b-icon>
          </strong>
          <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
        </div>
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr v-if="items.length > 0">
            <th v-for="column in columns" v-bind:key="column.value" scope="col">
              <div class="flex">
                <span v-if="column.value !== 'CRUD'" class="col-text cursor-pointer" @click="SortInvert(column.value)">{{
                    column.name
                  }}</span>
                <span v-if="column.value !== 'CRUD'" class="icon-up" v-show="sortField==column.value"><b-icon
                    icon="arrow-up"></b-icon></span>
                <span v-if="column.value !== 'CRUD'" class="icon-down" v-show="sortField=='-'+column.value"><b-icon
                    icon="arrow-down"></b-icon></span>
              </div>
            </th>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <FiltersV2
              :itemsSelectedCount="itemsSelectedCount"
              v-on:onChanged="filterChanged"
              v-on:onInit="filterInit"
              :title="title"
              @changeTitle="changeTitle"
              :filter="filter"
              :filterValues="filterValues"
              :columns="columns"
              :filterExact="filterExact"
              @deleteItems="openDeleteItemsConfirmation"
          />
          </thead>
          <tbody v-if="items.length > 0">
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td v-for="column in columns"
                v-bind:key="column.value">
              <span v-if="column.buttons !== undefined" class="cel-buttons">
                <button v-if="column.buttons.includes('edit')" class="btn btn-as-link icon-only"
                        @click="editItem(item)">
                  <i class="fa fa-pencil"></i>
                </button>
                <button v-if="column.buttons.includes('delete')" class="btn btn-as-link icon-only  text-danger"
                        @click="openDeleteItemConfirmation(item)">
                  <i class="fa fa-trash"></i>
                </button>
              </span>
              <span v-if="column.links !== undefined" class="cel-buttons">
                <button v-for="link in column.links" v-bind:key="link.value" class="btn btn-as-link icon-only"
                        @click="linkItem(link.url,item)">
                  <img v-if="link.icon.type=='bitmap'" :title="link.text" class="item-icon"
                       :src="`/img/${link.icon.value}`">
                  <b-icon v-if="link.icon.type=='vector'" :icon="link.icon.value"></b-icon>
                  <i v-if="link.icon.type=='fa'" :class="link.icon.value"></i>
                </button>
              </span>
              <span v-else-if="column.template !== undefined" class="cel-text"
                    v-html="fillTemplate(column.template.value, item)"></span>
              <span v-else-if="column.value.toLowerCase() === 'state'" v-tippy="{arrow : true}"
                    :content="'state: ' + item.State + ' Discovered At: ' + item.DiscoveredAt">
                 <span v-if="item.State === 'OK'" style="all: initial;">🟢</span>
                <span v-else-if="item.State === 'NO PING'" style="all: initial;">🔴</span>
                <span v-else-if="item.State === '' || item.State === null" style="all: initial;">0️⃣️</span>
              </span>
              <span v-else class="cel-text">{{ item[column.value] }}</span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="options"
        />
      </div>
    </div>

    <ModalItem
        type="edit"
        :title="updateTitle"
        :updateTitleKey="updateTitleKey"
        :itemId=currentItemId
        :item=currentItem
        :modalName="'editItem'"
        :height="modalHeightEdit"
        v-on:onSuccess="itemSuccess"/>
    <ModalItem
        type="create"
        :title="createTitle"
        :itemId=currentNewItemId
        :modalName="'createItem'"
        :height="modalHeightCreate"
        v-on:onSuccess="itemSuccess"/>
    <ModalLog :data="textareaData" :modalName="'modalTextarea'"/>
    <ModalError name="listError" :message="error"/>
    <ModalSuccess name="listSuccess" :message="success"/>
    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :url="apiUrl"
        :itemId="currentItemId"
    />
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>
  </div>
</template>
<script>

import axios from "axios";
import {ListLogicMixin} from '../assets/js/mixins/list-logic-mixin';

export default {
  name: 'listPage',
  mixins: [
    ListLogicMixin
  ],
  props: {
    showCreateButton: {
      type: Boolean,
      default: true
    },
    updateTitle: String,
    updateTitleKey: String,
    createTitle: String,
    modalHeightCreate: {
      type: Number,
      default: 270
    },
    modalHeightEdit: {
      type: Number,
      default: 270
    },
    list: String,
    url: String,
  },
  components: {},
  data() {
    return {
      pageTitle: '...',
      title: '...',
      editTitle: this.updateTitle,
      items: [],
      allSelected: false,
      currentItemId: -1,
      currentNewItemId: -1,
      currentItem: {},
      apiItem: '',
      apiList: this.list,
      apiUrl: this.url,
      apiConfig: '/api/config/list',
      columns: [],
      options: [],
      textareaData: '',
      dataKeysForStore: ['limit', 'sortField'],
    };
  },

  methods: {
    LoadConfig() {
      if (this.$route.query.page != undefined) {
        this.pageNumber = this.$route.query.page;
      } else {
        this.pageNumber = 1;
      }
      this.title = '...';
      this.filter = [];
      this.items = null;
      this.error = '';
      let pageName = this.$route.params.page;
      if (!pageName) {
        pageName = this.$route.name;
      }
      axios.get(`${this.apiConfig}/${pageName}`,
          this.authRespConf())
          .catch((err) => {
            this.loading = 'loaded';
            this.errorHandle(err);
          })
          .then(res => {
            this.loading = 'loaded';
            //console.log('loaded config');
            if (res !== null && res !== undefined) {
              if (res.data !== null && res.data !== undefined) {
                this.title = res.data.title;
                this.buttons = res.data.buttons;
                if (res.data.buttons) {
                  this.buttons = res.data.buttons;
                }
                this.filter = res.data.filter;

                if (Object.keys(this.filterValues).length === 0) {
                  this.filterValues = res.data.filterValues;
                }
                if (res.data.apiList !== '/api/manager/esxi/list') {
                  this.apiList = res.data.apiList;
                }
                this.apiItem = res.data.apiItem;
                this.apiUrl = res.data.apiUrl;
                this.sortField = res.data.sortField;
                this.columns = res.data.columns;
                this.realColumns = res.data['real-columns'] ?? [];
                this.options = res.data.options;
                this.limit = res.data.limit;
                this.apiMultyDelete = res.data.apiMultyDelete;
                this.ApplyUserConfig();
                this.filterPreparing();
                this.filterQuery();
                this.LoadData();
              }
            }
          });
    },
    changeTitle(title) {
      this.title = title;
    },
    selectAll: function () {
      this.selectedItemsList = [];
      this.itemsSelectedCount = 0
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
    },
    select: function () {
      this.allSelected = false;
    },
    eventTrigger() {
      console.log('============== TABLE RELOAD ====================');
      return 'reloaded-content';
    },
    editItem(item) {
      //this.$router.push({path: this.apiItem + item.Id});
      this.currentItemId = parseInt(item.Id);
      this.currentItem = item;
      this.$modal.show('editItem');
    },
    getAndShowDiscoverLogs() {
      let loader = this.$loading.show();
      this.loading = 'loading';
      axios.post('/api/log/list?limit=20&sort=-id&page=1',
          [{"Condition": "ilike", "Data": {"Entity": "DiscoverHV"}}],
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              let last_log = res.data.data[0];
              this.textareaData = last_log.Data;
              this.$modal.show('modalTextarea');
            } else {
              this.errorHandle(res, true, true, "Something wrong, no logs found.");
            }
          });
    },

  },
  computed: {},
  watch: {
    '$route': function (val) {
      console.log('list watch $route', val);
      this.onRouteChange();
      this.setTitleByFilters();
    },
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
    }
  },
  created: function () {
    this.filterQuery();
    this.LoadConfig();
  },
  mounted() {
    this.$nextTick(function () {
      //this.initResizable();
    });
  },
  updated: function () {
    //this.columnsReset();
    //this.updateResizable();
  }
};
</script>
